module.exports = __webpack_public_path__ + "static/media/HospedeCosta.b61ea098.jpeg";